import { CrudAbstractModel } from "../../crud-abstract/crud-abstract.model";
import { Rate } from "../rate-type";
import { RateMapper } from "../rate.mapper";
import { RateFlatRouteMapper } from "./rate-flat-route.mapper";
import { RateFlatRoute } from "./rate-flat-route.type";

export class RatePtlFlatRoute extends CrudAbstractModel {
  constructor(
    public id: number,
    public discriminator: string,
    public rate: Rate,
    public comment: string,
    public currency: string,
    public originPostalCodeMin: string,
    public originPostalCodeMax: string,
    public originCountry: string,
    public destinationPostalCodeMin: string,
    public destinationPostalCodeMax: string,
    public destinationCountry: string,
    public blPrice: number,
  ) {
    super(id);
  }

  public getId(): number {
    return this.id;
  }

  public getDiscriminator(): string {
    return this.discriminator;
  }

  public setId(param: number) {
    this.id = param;
  }

  public getRate(): Rate {
    return this.rate;
  }

  public getRequestParams() {
    return {
      comment: this.comment,
      currency: this.currency,
      originPostalCodeMin: this.originPostalCodeMin,
      originPostalCodeMax: this.originPostalCodeMax,
      originCountry: this.originCountry,
      destinationPostalCodeMin: this.destinationPostalCodeMin,
      destinationPostalCodeMax: this.destinationPostalCodeMax,
      destinationCountry: this.destinationCountry,
      blPrice: this.blPrice,
    };
  }

  public isValid(): boolean {
    return !!this.originPostalCodeMin && !!this.originPostalCodeMax;
  }

  public getClone(): RateFlatRoute {
    return RateFlatRouteMapper.map({
      id: this.getId(),
      discriminator: this.discriminator,
      rate: RateMapper.map(this.rate),
      comment: this.comment,
      currency: this.currency,
      originPostalCodeMin: this.originPostalCodeMin,
      originPostalCodeMax: this.originPostalCodeMax,
      originCountry: this.originCountry,
      destinationPostalCodeMin: this.destinationPostalCodeMin,
      destinationPostalCodeMax: this.destinationPostalCodeMax,
      destinationCountry: this.destinationCountry,
      blPrice: this.blPrice,
    });
  }
}
